//package imports 
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//component imports
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import CustomModal from "../../utils/resuableComponents/CustomModal";
import Switch from "@mui/material/Switch";
import FaqModal from "../../utils/resuableComponents/FaqModal";
import { FaqList } from "../../services/apiServices/GetServices";
import { createFaqApi, updateFaq } from "../../services/apiServices/PostServices";
import { showToast } from "../../utils/constants/Toaster";
import Loader from "../loadingScreens/Loader";


const DataManagement = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [faqList, setFaqList] = useState([]);
    const [faqData, setFaqData] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const [modalData, setModalData] = useState("")
    const [modalEdit, setModalEdit] = useState("")
    const [searchTerm, setSearchTerm] = useState('');
    const [checked, setChecked] = useState("")
    const [modalContentData,setModalContentData] = useState("");
    const [disableModal, setDisableModal] = useState(false);
    const [isLoader,setIsLoader]=useState(false)
    const values = faqList.map((data) => data?.status === 1 ? true : false)


    useEffect(() => {
        faqListApi()
    }, []);

    useEffect(() => {
        if (faqList.length > 0) {
            setSwitchValue(values)
        }
    }, [faqList.length]);

    useEffect(() => {
        if (filteredData.length != 0) {
            setFaqData(filteredData)
        }
    }, [filteredData])

    const [switchValue, setSwitchValue] = useState(
        new Array(faqList.length).fill(true)
    );
    
    //function call to open modal
    const openModal = () => {
        setModalData("")
        setModalEdit("")
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setModalData("")
        setIsModalOpen(false);
    };

    //fuction call to open edit modal
    const handleOpenEdit = (data) => {
        setModalEdit("Edit")
        setModalData(data)
        setIsModalOpen(true);
    }
    
    //function call to close disable request modal
    const closeDisableModal = () => {
        setSwitchValue(values)
        setDisableModal(false)
        
    }
    // Function to add new FAQ to the list
    const addNewFAQ = async (newFAQ) => {
        try{
            const res = await createFaqApi("faq", newFAQ)
            if (res?.success) {
                showToast(1, res?.message)
                faqListApi()
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    };

    //function call for editing the faq question and answer
    const onClickEdit = async (editData) => {
        try{
            const res = await updateFaq("faq", editData)
            if (res?.success) {
                showToast(1, res?.message)
                faqListApi()
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    const handleModalContent = (val) =>{
       if(val === 1){
        setModalContentData("Are you sure want to enable the faq question?")
       }else{
        setModalContentData("Are you sure want to disable the faq question?")
       }
    }

    //funtion to disable question 

    const handledisable = async () => {
        try {
            const reqbody = {
                id:modalData?.id,
               question:modalData?.question,
                answer:modalData?.answer,
                status:checked
                    }
                    const res = await updateFaq("faq", reqbody)
                    if (res?.success) {
                        showToast(1, res?.message)
                        setDisableModal(false)
                        faqListApi()
                    } else {
                        console.log("res", res?.message)
                    }
        }catch(error){
            console.log("error",error)
        }
       
    }

    //function to hanlde search
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            faqListApi()
        } else {
            setSearchTerm(searchVal);
            const filterdata = faqList.filter((item) => {
                if (item?.question.toLowerCase()
                    .includes(searchVal.toLowerCase())) { return item; }
            })
            setFilteredData(filterdata)
        }
    }

    //function call for viewing the modal
    const handleViewModal = (data) => {
        setModalEdit("View")
        setModalData(data)
        setIsModalOpen(true);
    }

    //function to call Faq List Api
    const faqListApi = async () => {
        setIsLoader(true)
        try{
            const res = await FaqList("faq")
            if (res?.success) {
                setFaqList(res?.data)
                setFilteredData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
       
    }

    //function call for compressing the paragraph of the faq question with limited lines
    const TruncatedParagraph = ({ text, maxWords, minLines }) => {
        // Split the text into an array of words
        const words = text.split(' ');
        // Take the first 'maxWords' words
        const truncatedText = words.slice(0, maxWords).join(' ');
        return (
            <div className={`truncated-paragraph ${minLines <= 2 ? 'max-lines-2' : 'max-lines-2'}`}>
                {truncatedText} {words.length > maxWords && '...'}
            </div>
        );
    };

    //function to hanlde switch 
    const handleSwitch = (e, position,data) => {
        const updatedCheckedState = switchValue.map((item, index) =>
            index === position ? !item : item
        );
        setSwitchValue(updatedCheckedState)
        setDisableModal(true)
        setModalData(data)
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null}
            <div class="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 class="fs-4 mx-3 Montserrat fw-semi-bold">
                    FAQ Management
                </h1>
            </div>
            <div >
            <div class="d-flex flex-row justify-content-between">
                <CusotomSearch onChange={handleSearch} />
                <div class="d-flex flex-row align-items-center">
                    <a onClick={() => openModal()}>
                        <div class="d-flex mx-2 pointer">
                            <h6 class="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0 w-100">
                                Add
                            </h6>
                            <i class="bi bi-plus-square colorPrimary"></i>
                        </div>
                    </a>
                </div>
            </div>    

        <hr class="hr w-100 m-0" />
            {
                filteredData.length !== 0 ?
                <div class="container d-flex flex-row h-50 flex-wrap mt-4">
                {filteredData.map((data, index) => (
                    <div key={index} class="col-sm-4  p-4 ml-5" style={{position: "relative"}}>
                        <div class="shadow rounded h-100 p-3 d-flex flex-column" >
                            <div class="card-body d-flex flex-row justify-content-between">
                                <h5 class="overflow-hidden" onClick={() => handleViewModal(data)}>{data?.question}</h5>
                                    <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#0A2FB6",cursor:"pointer" }} onClick={() => handleOpenEdit(data)} />
                            </div>
                            <div class="card-body text-left">
                                <TruncatedParagraph text={data?.answer} maxWords={15} maxLines={2} />
                               </div>
                               <div class="card-footer align-self-center"> 
                                <Switch checked={switchValue[index]}
                                    onClick={(e) => {
                                        handleSwitch(e?.target?.checked, index,data)
                                        e.target.checked ? setChecked(1) : setChecked(0)
                                        e.target.checked ? handleModalContent(1) : handleModalContent(0) 
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))} 
                </div>
                :
                <div class="container d-flex flex-row justify-content-center align-items-center">
                    <h4 class="text-center">Data not found</h4>
                </div>
            } 
            <CustomModal
                        close={closeDisableModal}
                        open={disableModal}
                        modalContent={modalContentData}
                        Action={handledisable}
                    />
            <FaqModal open={isModalOpen} close={closeModal} addFAQ={addNewFAQ} edit={onClickEdit} data={modalData} dataEdit={modalEdit} statusChecked={checked} />

            </div>
        </div>
    )
}

export default DataManagement